import { useState } from 'react';
// Assuming you have a 'toast' utility for notifications
// import { toast } from 'react-hot-toast'; 

const Security = () => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const submitHandler = async (e) => {
        e.preventDefault();
        // Replace with your actual toast notifications
        if (newPassword === currentPassword) {
            console.warn("New password cannot be the same as the current password!");
            return;
        }
        if (newPassword !== confirmPassword) {
            console.warn("Passwords are not matching");
            return;
        }
        try {
            // const payload = { ... };
            // await api.changePassword(payload);
            console.log("Password changed successfully");
        } catch (err) {
            console.error("Failed to change password");
        } finally {
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
        }
    };

    return (
        <div className="bg-white dark:bg-neutral-800 rounded-lg p-6 shadow-sm">
            <h2 className="text-xl font-semibold text-neutral-800 dark:text-white mb-4">Change Password</h2>
            <form onSubmit={submitHandler} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-neutral-600 dark:text-neutral-400 mb-1">
                        Current Password
                    </label>
                    <input
                        type="password"
                        placeholder="••••••••"
                        required
                        className="w-full px-4 py-2 rounded-lg bg-neutral-100 dark:bg-neutral-700 border-transparent focus:border-blue-500 focus:ring-0"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-neutral-600 dark:text-neutral-400 mb-1">
                        New Password
                    </label>
                    <input
                        type="password"
                        placeholder="••••••••"
                        required
                        className="w-full px-4 py-2 rounded-lg bg-neutral-100 dark:bg-neutral-700 border-transparent focus:border-blue-500 focus:ring-0"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-neutral-600 dark:text-neutral-400 mb-1">
                        Confirm New Password
                    </label>
                    <input
                        type="password"
                        placeholder="••••••••"
                        required
                        className="w-full px-4 py-2 rounded-lg bg-neutral-100 dark:bg-neutral-700 border-transparent focus:border-blue-500 focus:ring-0"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </div>
                <div className="pt-2">
                    <button type="submit" className="px-4 py-2 bg-green-600 hover:bg-green-700 transition-colors rounded-lg text-white font-semibold">
                        Update Password
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Security;
